import { useState, useEffect } from 'react';

interface WindowSize {
  width: number;
  isDesktop: boolean;
}

export function useWindowSize(desktopBreakpoint: number): WindowSize {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: 0,
    isDesktop: false
  });

  useEffect(() => {
    function handleResize() {
      const width = window.innerWidth;
      setWindowSize({
        width,
        isDesktop: width >= desktopBreakpoint
      });
    }

    // Initial call
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [desktopBreakpoint]);

  return windowSize;
}